import { render, staticRenderFns } from "./reference-popup-view.vue?vue&type=template&id=6a85e561&scoped=true&"
import script from "./reference-popup-view.vue?vue&type=script&lang=js&"
export * from "./reference-popup-view.vue?vue&type=script&lang=js&"
import style0 from "./reference-popup-view.vue?vue&type=style&index=0&id=6a85e561&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a85e561",
  null
  
)

export default component.exports